import React, { ReactNode } from 'react';

interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <div className="group relative rounded-2xl transition-transform duration-300 ease-out hover:scale-[1.02]">
      {/* Animated border gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary-light via-secondary-light to-primary-light dark:from-primary-dark dark:via-secondary-dark dark:to-primary-dark opacity-0 group-hover:opacity-20 transition-opacity duration-300 rounded-2xl animate-gradient bg-[length:200%_auto]" />
      
      {/* Glass container */}
      <div className="relative h-full p-4 rounded-xl bg-gradient-to-br from-background-light/80 to-surface-light/80 dark:from-background-dark/80 dark:to-surface-dark/80 backdrop-blur-md border border-border-light dark:border-border-dark">
        {/* Icon */}
        <div className="mb-4 text-primary-light dark:text-primary-dark">
          {icon}
        </div>

        {/* Content */}
        <h3 className="text-lg font-semibold mb-2 text-text-primary-light dark:text-text-primary-dark">
          {title}
        </h3>
        <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
          {description}
        </p>
      </div>
    </div>
  );
}